module.exports = __webpack_public_path__ + "media/customizations/avimor/back-f86abc4fac232e319fcfbd849f2a8930.jpg";